export default __webpack_public_path__ + "static/media/PageIcon.9a0e4d8d.svg";